import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Form, Input, Button, Select, message, Spin, Checkbox } from "antd";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import { receiveError } from "../../../api/http";

// import CreateReport from '../EachAccount/eachaccount';

// import wasabiDarkLogo from "../../../assets/logo/wasabi_header_logo_dark.png";
import wasabiDarkLogo from "../../../assets/logo/amove-dark-logo.svg";

import "./addNewUser.scss";

class AddNewUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      accountList: [],
      selectedAccount: null,
      selectedUserType: null,
    };
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    CloudFlyerAPI.user_account
      .fetchAllAccounts(0, 1)
      .then(({ data }) => {
        this.setState({
          loading: false,
          accountList: data.data,
        });
      })
      .catch((err) => {
        const msg = receiveError(null, err).message;
        message.error(msg);
      });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    console.log("submit account");
    const { firstname, lastname, email } = this.props.form.getFieldsValue();

    CloudFlyerAPI.user_account
      .addUser({
        firstname,
        lastname,
        username: email,
        email,
        accountId: this.state.selectedAccount,
        userType: parseInt(this.state.selectedUserType),
      })
      .then(function(response) {
        message.success("User Added Successfully!");
      })
      .catch(function(err) {
        message.error("Something went wrong!");
      });
  };

  on_account_change = (e) => {
    this.setState({
      selectedAccount: e,
    });
  };

  on_user_change = (e) => {
    console.log(e);
    this.setState({
      selectedUserType: e,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { Option } = Select;
    return (
      <div className="add-new-user-container">
        <div className="content-box">
          <div className="wasabiLogo">
            <img alt="wasabi Logo" src={wasabiDarkLogo} />
          </div>

          <div className="add-user-form">
            <Form
              layout="horizontal"
              onSubmit={this.handleSubmit.bind(this)}
              className="user-form"
            >
              <Form.Item>
                {getFieldDecorator("firstname")(
                  <Input
                    id="firstName"
                    placeholder="First Name"
                    className="user-input"
                  />
                )}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator("lastname")(
                  <Input
                    id="lastName"
                    placeholder="Last Name"
                    className="user-input"
                  />
                )}
              </Form.Item>
              <Form.Item>
                {getFieldDecorator("email")(
                  <Input
                    id="email"
                    placeholder="Email"
                    className="user-input"
                    type="email"
                  />
                )}
              </Form.Item>
              <Form.Item name="accountName" rules={[{ required: true }]}>
                <Select
                  showSearch
                  placeholder="Search to Select Account"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  onChange={(e) => this.on_account_change(e)}
                >
                  {this.state.accountList.map((data, index) => (
                    <Option key={index} value={data.id}>
                      {data.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="userType" rules={[{ required: true }]}>
                <Select
                  placeholder="Select User Type"
                  onChange={(e) => this.on_user_change(e)}
                  allowClear
                >
                  <Select.Option key={1}>Wasabi Admin</Select.Option>
                  <Select.Option key={4}>Account Admin</Select.Option>
                  <Select.Option key={8}>Account User</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item>
                <Button
                  className="user-btn"
                  type="primary"
                  size="large"
                  loading={this.state.loading}
                  htmlType="submit"
                  block
                >
                  Invite User
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect()(Form.create()(AddNewUser)));
